import { graphql } from "./generated/gql";

export const SponsorReminderSettingQuery = graphql(`
  query SponsorReminderSetting($termId: ID!) {
    sponsorReminderSetting(termId: $termId) {
      sponsorReminderSettingId
      termId
      title
      description
      enabled
      recipientEmails
      conditions {
        daysBeforeDeadline
        sendDate
        completionRateThreshold
      }
      createdAt
      updatedAt
    }
  }
`);

export const UpsertSponsorReminderSettingMutation = graphql(`
  mutation UpsertSponsorReminderSetting($input: UpsertSponsorReminderSettingInput!) {
    upsertSponsorReminderSetting(input: $input) {
      sponsorReminderSettingId
      termId
      title
      description
      enabled
      recipientEmails
      conditions {
        daysBeforeDeadline
        sendDate
        completionRateThreshold
      }
      createdAt
      updatedAt
    }
  }
`);
